import React from 'react'
import { Typography } from 'antd'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'
import { Organisation } from '../../../services/ApiContext'

const { Text } = Typography

interface Props {
  purchaseOrder: CompletedPurchaseOrder
  organisation: Organisation
}

export const PurchaseOrderHeader: React.FC<Props> = ({
  purchaseOrder,
  organisation
}) => {
  const { poNumber, date, quoteReference } = purchaseOrder

  return (
    <div className="mb-8">
      <div
        className="h-2 mb-6"
        style={{
          background: `${organisation.primaryColor})`
        }}
      />

      <div className="flex justify-between items-start gap-8">
        {organisation.logo && (
          <img
            src={organisation.logo}
            alt={organisation.name}
            className="w-[150px] object-contain"
          />
        )}

        <div className="text-right">
          <Text strong className="block text-xl">
            {organisation.name}
          </Text>
          <Text className="block whitespace-pre-line">
            {organisation.address}
          </Text>
          {organisation.phone && (
            <Text className="block">{organisation.phone}</Text>
          )}
          {organisation.email && (
            <Text className="block">{organisation.email}</Text>
          )}
          {organisation.taxNumber && (
            <Text className="block">
              Tax/GST Number: {organisation.taxNumber}
            </Text>
          )}
        </div>
      </div>

      <div className="mt-8 text-start">
        <Text className="text-2xl font-bold block">Purchase Order</Text>
        {poNumber && <Text className="text-lg block">PO #{poNumber}</Text>}
        {quoteReference && (
          <Text className="text-lg block">
            Quote Reference {quoteReference}
          </Text>
        )}
        <Text className="block">
          Date: {new Date(date).toLocaleDateString()}
        </Text>
      </div>
    </div>
  )
}
